<template>
  <div v-if="isOpen" class="crm-groups-form">
    <PmwParagraph
      v-if="showTitle"
      size="paragraph-80"
      weight="light"
      class="crm-groups-form--title"
    >
      {{ title }}
    </PmwParagraph>

    <div
      :class="{ 'crm-groups-form-content__with-list': showSelectedGroupsList }"
      class="crm-groups-form-content"
    >
      <PmwTreeviewSelector
        :value="selectedGroups"
        :rows="filteredRows"
        :showSkeletonLoader="showSkeletonLoader"
        selectionBoxTitle=""
        class="crm-groups-form--selector"
        @search="searchGroups = $event"
        @input="inputHandler"
      />

      <PmwSelectedItemsList
        v-if="showSelectedGroupsList"
        :items="selectedGroups"
        emptyMessage="Nenhum grupo selecionado"
        selectedPlaceholder="Buscar grupo selecionado"
        class="crm-groups-form--list"
        @deleteItem="removeGroup"
      />
    </div>
  </div>
</template>

<script>
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwTreeviewSelector from '@solucoes/components-lib-tmp/src/components/patterns/PmwTreeviewSelector'

const PmwSelectedItemsList = () =>
  import(
    /* webpackPrefetch: true */ '@/components/_base/patterns/PmwSelectedItemsList/PmwSelectedItemsList.vue'
  )

export default {
  name: 'CRMGroupsForm',

  components: {
    PmwParagraph,
    PmwTreeviewSelector,
    PmwSelectedItemsList
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    },

    isOpen: {
      type: Boolean,
      default: false
    },

    hotelId: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: 'Grupos CRM'
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    /** Se deve apresentar uma lista com os grupos selecionados */
    showSelectedGroupsList: Boolean
  },

  data() {
    return {
      rows: [],

      showSkeletonLoader: false,

      searchGroups: ''
    }
  },

  computed: {
    filteredRows() {
      return this.rows.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.searchGroups.toLowerCase()) > -1
      )
    },

    /**
     * Tornar a seleção de grupos recursivamente
     * E selecionar os itens filhos quando o grupo pai for selecionado
     */
    selectedGroups() {
      const selectedGroups = []

      const findGroup = (rows, groupId) => {
        for (const group of rows) {
          if (group.id === groupId) selectedGroups.push(group)

          if (group.children && group.children.length) {
            findGroup(group.children, groupId)
          }
        }
      }

      if (this.value.gruposCrm && this.value.gruposCrm.length) {
        this.value.gruposCrm.forEach((groupId) => {
          findGroup(this.rows, groupId)
        })
      }

      return selectedGroups
    }
  },

  created() {
    this.getGroups()
  },

  methods: {
    /** Busca os grupos CRM */
    getGroups() {
      if (this.hotelId) {
        this.$hotel.getCrmGroups(this.hotelId).then((response) => {
          this.rows = this.formatCrmGroupsData(response.data)
        })
      } else {
        this.$masterRates.getCrmGroups().then((response) => {
          this.rows = this.formatCrmGroupsData(response.data)
        })
      }
    },

    /**
     * Formatar lista para a seleção de grupos
     * @param {Array} crmGroupsData: Opções selecionaveis de grupos crm
     */
    formatCrmGroupsData(crmGroupsData) {
      return crmGroupsData.map((group) => {
        const formattedGroup = {
          id: group.codigo,
          name: group.nome
        }

        if (group.filhos && group?.filhos?.length > 0) {
          /** Tornar a função recursiva */
          formattedGroup.children = this.formatCrmGroupsData(group.filhos)
        }

        return formattedGroup
      })
    },

    /**
     * Passa o valor do input para o value
     * @param {array} event: grupos selecionados
     */
    inputHandler(event) {
      this.value.gruposCrm = event.map((item) => item.id)
    },

    /**
     * Removido um item da seleção
     * @param {object} item Objeto do item removido
     */
    removeGroup(item) {
      this.value.gruposCrm = this.value.gruposCrm.filter(
        (group) => group !== item.id
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.crm-groups-form {
  &--title {
    margin: 35px 0 10px;
  }

  &--selector {
    width: 50%;
  }

  &--list {
    margin-top: pmw-space(2) !important;
  }

  &-content {
    &__with-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: pmw-space(4);
      align-items: start;

      .crm-groups-form {
        &--selector {
          width: 100%;
        }
      }
    }
  }
}
</style>
